import { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';

function FormErrorNotification({ debug, onValidationError }) {
  const {
    errors,
    isValidating,
    submitCount,
    values,
  } = useFormikContext();

  const onValidationErrorRef = useRef(onValidationError);

  useEffect(() => {
    onValidationErrorRef.current = onValidationError;
  }, [onValidationError]);

  useEffect(() => {
    if (submitCount > 0 && !isValidating) {
      onValidationErrorRef.current(errors);
    }
  }, [errors, isValidating, submitCount]);

  return (debug
    ? <>
      <hr />
      <pre
        children={JSON.stringify({
          errors,
          values,
        }, null, '  ')}
      />
      <hr />
    </>
    : null);
};

FormErrorNotification.propTypes = {
  debug: PropTypes.bool,
  onValidationError: PropTypes.func,
};

export default FormErrorNotification;
